export const getFormattedFormType = (formType, applicationType) => {
    let formattedType;

    switch(formType) {
        case 'attendance':
            formattedType = "Attendance";
            break;
        case 'leave-undertime':
            if (applicationType === 'leave') {
                formattedType = "Leave";
            } else if (applicationType === 'undertime') {
                formattedType = "Undertime";
            } else {
                formattedType = "Leave & Undertime";
            }
            break;
        case 'travel-order':
            formattedType = "Travel Order";
            break;
        case 'ot-request':
            formattedType = "OT Request";
            break;
        default:
            formattedType = "N/A";
    }

    return formattedType;
}

export const getFormDataObject = (form) => {

    const {
        formType,
        applicationType,
        paymentType,
        leaveType,
        leaveTypeDetail,
        startDate,
        endDate,
        department,
        hoursRequested,
        travelArea,
        date,
        timeIn,
        lunchStart,
        lunchEnd,
        timeOut,
        timeFrom,
        timeTo,
        leavePaidDays,
        leaveWithoutPayDays,
        leaveDayAllocations,
        leaveAllocations,
        reason,
    } = form;

    let dataObject;

    switch(formType) {
        case 'attendance':
            dataObject = {
                date,
                timeIn,
                lunchStart,
                lunchEnd,
                timeOut,
                reason
            };
            break;
        case 'leave-undertime':
            dataObject = {
                date,
                startDate,
                endDate,
                applicationType,
                paymentType,
                leaveType,
                leaveTypeDetail,
                timeFrom,
                timeTo,
                leavePaidDays,
                leaveWithoutPayDays,
                leaveDayAllocations,
                leaveAllocations,
                reason
            };
            break;
        case 'travel-order':
            dataObject = {
                department,
                startDate,
                endDate,
                travelArea,
                reason,
            };
            break;
        case 'ot-request':
            dataObject = {
                department,
                hoursRequested,
                reason
            };
            break;
        default:
            dataObject = null;
    }

    return dataObject;
}
